import { render } from "./About.vue?vue&type=template&id=cc21f2c0"
const script = {}

import exportComponent from "C:\\inetpub\\wwwroot\\Malak-Al-Tawouk-Website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__